import { render, staticRenderFns } from "./UnassignedStudents.vue?vue&type=template&id=23261f83&scoped=true&"
import script from "./UnassignedStudents.vue?vue&type=script&lang=js&"
export * from "./UnassignedStudents.vue?vue&type=script&lang=js&"
import style0 from "./UnassignedStudents.vue?vue&type=style&index=0&id=23261f83&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23261f83",
  null
  
)

export default component.exports